import { DnsRecordsTable } from '../DnsRecordsTable/index.js'

export const TransferWizardSkeleton = () => {
  return (
    <div className="animate-pulse">
      <div className="flex-1 space-y-4 py-1">
        <div className="h-6 bg-skeleton rounded-full w-1/3" />
        <div className="h-4 bg-skeleton rounded-full w-5/6" />
        <DnsRecordsTable isLoading dnsRecords={[]} />
        <div className="h-4 bg-skeleton rounded-full" />
        <div className="flex justify-end space-x-4">
          <div className="h-8 bg-skeleton rounded w-1/4" />
          <div className="h-8 bg-skeleton rounded w-1/4" />
        </div>
      </div>
    </div>
  )
}
